export default __webpack_public_path__ + "static/media/Wristband of the Faceless Chaos.fb8e4d6a.jpg";